import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ff772aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_header = _resolveComponent("page-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_swiper_category_data = _resolveComponent("swiper-category-data")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_page_header, {
        parentPath: $setup.parentPath ? $setup.parentPath : '/merchants'
      }, null, 8, ["parentPath"]),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, { fixed: "" }, {
            default: _withCtx(() => [
              ($setup.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_ion_spinner)
                  ]))
                : _createCommentVNode("", true),
              (!$setup.loading && $setup.merchant)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("img", {
                      class: "banner-img",
                      src: $setup.merchant.bannerLink
                    }, null, 8, _hoisted_3),
                    _createVNode(_component_ion_grid, { class: "ion-text-center" }, {
                      default: _withCtx(() => [
                        ($setup.userLoggedIn)
                          ? (_openBlock(), _createBlock(_component_ion_col, { key: 0 }, {
                              default: _withCtx(() => [
                                ($setup.merchant.likedByUser)
                                  ? (_openBlock(), _createBlock(_component_ion_button, {
                                      key: 0,
                                      class: "button",
                                      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.updateLikedMerchant($setup.merchant, 'remove')))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString($setup.t('MerchantPage.unfollow')), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createBlock(_component_ion_button, {
                                      key: 1,
                                      class: "button",
                                      onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.updateLikedMerchant($setup.merchant, 'add')))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString($setup.t('MerchantPage.follow')), 1)
                                      ]),
                                      _: 1
                                    }))
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_ion_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_button, {
                              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.shareMerchant($setup.merchant)))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString($setup.t('MerchantPage.share')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_card, { class: "no-border-card" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_col, {
                              class: "ion-text-center",
                              size: "4"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("img", {
                                  class: "logo-shadow",
                                  src: $setup.merchant.logoLink
                                }, null, 8, _hoisted_4)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_col, { size: "8" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_card_header, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_card_subtitle, {
                                      color: "dark",
                                      class: "ion-text-nowrap merchant-name"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString($setup.merchant.name), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_card_subtitle, { class: "ion-text-nowrap" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString($setup.getLocalizedStr($setup.merchant, 'productCategoryTitles', 'productCategoryTitlesEn')), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_card_subtitle, { class: "ion-text-nowrap" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString($setup.t('MerchantPage.numOfProducts')) + " " + _toDisplayString($setup.merchant.numOfProducts), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _hoisted_5
                  ]))
                : _createCommentVNode("", true),
              (!$setup.loading)
                ? (_openBlock(), _createBlock(_component_swiper_category_data, {
                    key: 2,
                    allCategories: $setup.merchantProducts.categories,
                    allProducts: $setup.merchantProducts.products,
                    hideMerchantName: true,
                    showActionButtons: true,
                    userLoggedIn: $setup.userLoggedIn
                  }, null, 8, ["allCategories", "allProducts", "userLoggedIn"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}